module.exports = __webpack_public_path__ + "885a656930325437fa7366f88f224c1f.pdf";